'use client';
import { signIn, signOut } from '@lib/auth';
import { AUTH_SYNC_COOKIE_NAME } from '@lib/constants/auth';
import Cookie from 'js-cookie';
import { useSession } from 'next-auth/react';
import { stringToBoolean } from 'utils';
import { useRecheckOnTabReturn } from './useRecheckOnTabReturn';

type WithAuthSyncProps = {
  /**
   * Re-read the auth sync cookie on return, as no focus refetch will, and
   * refetch the session quietly at most every few minutes.
   */
  recheckOnTabReturn?: boolean;
};

export const WithAuthSync = ({
  recheckOnTabReturn = false,
}: WithAuthSyncProps) => {
  const session = useSession();
  useRecheckOnTabReturn(recheckOnTabReturn, session.status === 'authenticated');
  const authSyncCookie = Cookie.get(AUTH_SYNC_COOKIE_NAME);

  if (
    authSyncCookie &&
    stringToBoolean(authSyncCookie) &&
    session.status === 'unauthenticated'
  ) {
    signIn({ clearAuthSync: true });
  }

  if (
    authSyncCookie &&
    stringToBoolean(authSyncCookie) === false &&
    session.status === 'authenticated'
  ) {
    signOut({ clearAuthSync: true });
  }

  return null;
};
